module.exports = __webpack_public_path__ + "img/v2.336af610.png";